


// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getPartnerDetails, getAllPartners, updatePartnerDetails, getAllDeliveryPartners,
//     verifyPartnerField, rejectPartnerField,
//     approvePartner, rejectPartnerApproval
// } from "../../../Servicefile/clientManagementService.jsx";

// // ============================================
// // PREMIUM ICONS COMPONENT
// // ============================================
// const Icons = {
//     Search: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
//         </svg>
//     ),
//     Refresh: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M23 4v6h-6M1 20v-6h6" />
//             <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
//         </svg>
//     ),
//     Clear: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
//         </svg>
//     ),
//     Back: () => (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <polyline points="15 18 9 12 15 6" />
//         </svg>
//     ),
//     Edit: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//             <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//         </svg>
//     ),
//     Check: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
//             <polyline points="20 6 9 17 4 12" />
//         </svg>
//     ),
//     X: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
//         </svg>
//     ),
//     Save: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
//             <polyline points="17 21 17 13 7 13 7 21" />
//             <polyline points="7 3 7 8 15 8" />
//         </svg>
//     ),
//     Export: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//             <polyline points="7 10 12 15 17 10" />
//             <line x1="12" y1="15" x2="12" y2="3" />
//         </svg>
//     ),
//     Approved: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
//             <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
//             <polyline points="22 4 12 14.01 9 11.01" />
//         </svg>
//     ),
//     Online: () => (
//         <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="12" cy="12" r="10" />
//             <path d="M12 6v6l4 2" />
//         </svg>
//     ),
//     Offline: () => (
//         <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="12" cy="12" r="10" />
//             <line x1="8" y1="8" x2="16" y2="16" />
//             <line x1="16" y1="8" x2="8" y2="16" />
//         </svg>
//     ),
//     NoData: () => (
//         <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
//             <rect x="2" y="3" width="20" height="18" rx="2" />
//             <line x1="8" y1="21" x2="16" y2="21" />
//             <line x1="12" y1="17" x2="12" y2="21" />
//             <path d="M8 7h8M8 11h6M8 15h4" />
//         </svg>
//     ),
//     Truck: () => (
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
//             <rect x="1" y="3" width="15" height="13" />
//             <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
//             <circle cx="5.5" cy="18" r="2.5" />
//             <circle cx="18.5" cy="18" r="2.5" />
//         </svg>
//     )
// };

// // ============================================
// // PREMIUM STYLES
// // ============================================
// const styles = {
//     container: {
//         padding: '1px 5px',

//         minHeight: '500px'
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '0 0 16px 0',
//         borderBottom: '2px solid #e9ecef',
//         flexWrap: 'wrap',
//         gap: '12px'
//     },
//     title: {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#2d3748',
//         letterSpacing: '-0.3px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     titleBadge: {
//         background: 'rgb(230 109 51)',
//         color: 'white',
//         fontSize: '12px',
//         fontWeight: '500',
//         padding: '2px 12px',
//         borderRadius: '12px',
//         letterSpacing: '0.3px'
//     },
//     filtersContainer: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         alignItems: 'center',
//         gap: '10px',
//         padding: '12px 0',
//         borderBottom: '1px solid #edf2f7',
//         marginBottom: '16px'
//     },
//     searchGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flex: '1 1 auto',
//         minWidth: '280px'
//     },
//     select: {
//         padding: '8px 12px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         background: 'white',
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         minWidth: '140px',
//         cursor: 'pointer'
//     },
//     input: {
//         flex: '1',
//         padding: '8px 14px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         background: 'white',
//         minWidth: '180px'
//     },
//     button: {
//         padding: '8px 16px',
//         borderRadius: '8px',
//         border: 'none',
//         fontWeight: '500',
//         fontSize: '13px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         whiteSpace: 'nowrap'
//     },
//     buttonPrimary: {
//         background: 'rgb(230 109 51)',
//         color: 'white'
//     },
//     buttonSecondary: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     buttonSuccess: {
//         background: '#48bb78',
//         color: 'white'
//     },
//     buttonDanger: {
//         background: '#fc8181',
//         color: 'white'
//     },
//     buttonWarning: {
//         background: '#ecc94b',
//         color: '#744210'
//     },
//     tableWrapper: {
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '500px',
//         position: 'relative'
//     },
//     table: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '1000px'
//     },
//     thead: {
//         position: 'sticky',
//         top: 0,
//         zIndex: 10
//     },
//     th: {
//         padding: '10px 12px',
//         textAlign: 'left',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: '#e66d33',
//         borderBottom: '2px solid #edf2f7',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '10px 12px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#2d3748',
//         fontSize: '13px'
//     },
//     statusBadge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '4px',
//         padding: '3px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '500',
//         letterSpacing: '0.3px'
//     },
//     statusOnline: {
//         background: '#bee3f8',
//         color: '#2a4365'
//     },
//     statusOffline: {
//         background: '#fed7d7',
//         color: '#9b2c2c'
//     },
//     statusVerified: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     statusPending: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     detailHeader: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//         padding: '16px 0',
//         borderBottom: '2px solid #e9ecef',
//         marginBottom: '16px',
//         flexWrap: 'wrap'
//     },
//     detailTitle: {
//         fontSize: '18px',
//         fontWeight: '600',
//         color: '#2d3748',
//         flex: 1
//     },
//     detailTableWrapper: {
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '550px'
//     },
//     detailTable: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '700px'
//     },
//     detailTh: {
//         padding: '10px 14px',
//         textAlign: 'center',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: 'rgb(230 109 51)',
//         border: '1px solid #dee2e6'
//     },
//     detailTd: {
//         padding: '10px 14px',
//         border: '1px solid #dee2e6',
//         verticalAlign: 'middle',
//         fontSize: '13px'
//     },
//     emptyState: {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '60px 20px',
//         color: '#a0aec0'
//     },
//     emptyStateText: {
//         marginTop: '16px',
//         fontSize: '16px',
//         fontWeight: '500',
//         color: '#4a5568'
//     },
//     emptyStateSubtext: {
//         fontSize: '13px',
//         color: '#a0aec0',
//         marginTop: '4px'
//     },
//     statsBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '16px',
//         padding: '8px 0 0 0',
//         fontSize: '12px',
//         color: '#718096',
//         flexWrap: 'wrap'
//     },
//     statItem: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '4px'
//     },
//     statNumber: {
//         fontWeight: '600',
//         color: '#2d3748'
//     },
//     approvalContainer: {
//         display: 'flex',
//         justifyContent: 'center',
//         gap: '12px',
//         padding: '20px 0',
//         marginTop: '16px',
//         borderTop: '2px solid #e9ecef',
//         flexWrap: 'wrap'
//     },
//     rejectCard: {
//         padding: '16px',
//         background: 'white',
//         borderRadius: '12px',
//         boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//         width: '320px',
//         position: 'absolute',
//         top: 'calc(100% + 8px)',
//         left: '50%',
//         transform: 'translateX(-50%)',
//         zIndex: 1000,
//         border: '1px solid #e2e8f0'
//     },
//     fieldLabel: {
//         fontWeight: '600',
//         color: '#2d3748',
//         fontSize: '13px'
//     },
//     fieldValue: {
//         color: '#4a5568',
//         fontSize: '13px'
//     }
// };

// // ============================================
// // HELPER FUNCTIONS (Same as before)
// // ============================================
// const getDefaultDeliveryPartnerRows = () => [
//     { key: "Full Name", value: "", isUpload: false },
//     { key: "Phone Number", value: "", isUpload: false },
//     { key: "Email", value: "", isUpload: false },
//     { key: "Profile Picture", value: null, isUpload: false },
//     { key: "AADHAR Number", value: "", isUpload: false },
//     { key: "PAN Number", value: "", isUpload: false },
//     { key: "License Number", value: "", isUpload: false },
//     { key: "Vehicle Types", value: [], isUpload: false },
//     { key: "Vehicles", value: [], isUpload: false },
//     { key: "Petrolium Types", value: [], isUpload: false },
//     { key: "RC Number", value: "", isUpload: false },
//     { key: "Insurance Number", value: "", isUpload: false },
//     {
//         key: "Bank Details", value: {
//             bankName: "",
//             accountNumber: "",
//             accountHolderName: "",
//             ifscCode: "",
//             branchName: "",
//             upiId: ""
//         }, isUpload: false
//     },
//     {
//         key: "Current Address", value: {
//             address: "",
//             city: "",
//             state: "",
//             pinCode: "",
//             country: "",
//             houseNo: "",
//             street: ""
//         }, isUpload: false
//     },
//     {
//         key: "Permanent Address", value: {
//             permanentAddress: "",
//             permanentCity: "",
//             permanentState: "",
//             permanentPinCode: "",
//             permanentCountry: "",
//             permanentHouseNo: "",
//             permanentStreet: ""
//         }, isUpload: false
//     }
// ];

// const vehicleTypeOptions = ["BIKE", "PASSENGER_AUTO", "CAR", "MINI_TRUCK", "TRUCK"];
// const vehiclesOptions = ["TwoWheeler", "ThreeWheeler", "FourWheeler", "HeavyVehicle"];
// const petroliumTypeOptions = ["PETROL", "DIESEL", "CNG", "ELECTRIC"];

// const STATUS_FIELD_MAP = {
//     "Full Name": "fullNameStatus",
//     "Phone Number": "phoneNumberStatus",
//     "Email": "emailStatus",
//     "Profile Picture": "profilePictureStatus",
//     "AADHAR Number": "aadharNumberStatus",
//     "PAN Number": "panNumberStatus",
//     "License Number": "licenseNumberStatus",
//     "Vehicle Types": "vehicleTypesStatus",
//     "Vehicles": "vehiclesStatus",
//     "Petrolium Types": "petroliumTypesStatus",
//     "RC Number": "rcNumberStatus",
//     "Insurance Number": "insuranceNumberStatus",
//     "Bank Details": "bankDetailsStatus",
//     "Current Address": "addressStatus",
//     "Permanent Address": "permanentAddressStatus"
// };

// const safeDisplay = (value) => {
//     if (value === null || value === undefined) return "N/A";
//     if (typeof value === 'string' && value.trim() === "") return "N/A";
//     if (value === "N/A" || value === "Invalid Date") return "N/A";
//     return value;
// };

// const hasValidData = (row, partnerDetails) => {
//     if (!row || !partnerDetails) return false;
//     const field = row.key;
//     const value = row.value;

//     if (typeof value === 'string') {
//         return value && value !== "N/A" && value.trim() !== "";
//     }
//     if (Array.isArray(value)) {
//         return value.length > 0 && value.some(item => item && item !== "N/A");
//     }
//     if (typeof value === 'object') {
//         return Object.values(value).some(val => {
//             if (val === null || val === undefined) return false;
//             if (typeof val === 'string') return val.trim() !== "" && val !== "N/A";
//             if (Array.isArray(val)) return val.length > 0;
//             return true;
//         });
//     }
//     return false;
// };

// const isFieldVerified = (rowKey, rowValue, partnerDetails) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];
//     if (!statusField || !partnerDetails) return false;
//     if (partnerDetails[statusField] === true) return true;
//     if ((partnerDetails[statusField] === null || partnerDetails[statusField] === undefined) &&
//         hasValidData({ key: rowKey, value: rowValue }, partnerDetails)) {
//         return true;
//     }
//     return false;
// };

// const isFieldRejected = (rowKey, partnerDetails) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];
//     if (!statusField || !partnerDetails) return false;
//     return partnerDetails[statusField] === false;
// };

// // ============================================
// // MAIN COMPONENT
// // ============================================
// const Logisticssubscribedclients = () => {
//     /* -------- list‑screen state -------- */
//     const [partnersData, setPartnersData] = useState([]);
//     const [statusFilter, setStatusFilter] = useState("");
//     const [vehicleFilter, setVehicleFilter] = useState("");
//     const [cityFilter, setCityFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);
//     const { showLoader, hideLoader } = useLoader();

//     /* -------- detail‑screen state -------- */
//     const [selectedPartner, setSelectedPartner] = useState(null);
//     const [partnerDetails, setPartnerDetails] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [rows, setRows] = useState(getDefaultDeliveryPartnerRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);
//     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

//     const fileInputRef = useRef(null);
//     const [partnerData, setPartnerData] = useState({});
//     const [rowId, setRowId] = useState(null);

//     const [showRejectDropdown, setShowRejectDropdown] = useState(false);
//     const [rejectionDescription, setRejectionDescription] = useState("");

//     const [isApproving, setIsApproving] = useState(false);
//     const [isRejecting, setIsRejecting] = useState(false);

//     const [refreshKey, setRefreshKey] = useState(0);

//     // Search filters
//     const [searchType, setSearchType] = useState("partnerId");
//     const [searchQuery, setSearchQuery] = useState("");

//     const searchOptions = [
//         { value: "partnerId", label: "Partner ID" },
//         { value: "fullName", label: "Full Name" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" }
//     ];

//     const getCurrentPartnerId = () => {
//         return (
//             selectedPartner?.id ||
//             selectedPartner?.partnerId ||
//             partnerDetails?.id ||
//             null
//         );
//     };

//     const partnerId = getCurrentPartnerId();

//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "partnerId": return "Search by Partner ID...";
//             case "fullName": return "Search by Full Name...";
//             case "email": return "Search by Email...";
//             case "phoneNumber": return "Search by Mobile...";
//             case "city": return "Search by City...";
//             default: return "Search...";
//         }
//     };

//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setVehicleFilter("");
//         setCityFilter("");
//         setStatusFilter("");
//     };

//     const handleImageError = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => new Set([...prev, errorKey]));
//     };

//     const handleImageLoad = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(errorKey);
//             return newSet;
//         });
//     };

//     const isImageFailed = (fieldName, index) => {
//         return imageLoadErrors.has(`${fieldName}-${index}`);
//     };

//     const fetchPartnerDetails = async (partnerId) => {
//         if (!partnerId) return;
//         setLoading(true);
//         const token = localStorage.getItem("authToken");

//         try {
//             const data = await getPartnerDetails(partnerId, token);
//             setPartnerDetails(data);
//         } catch (err) {
//             console.error("❌ get-partner-details error:", err);
//             const listPartner = partnersData.find(
//                 p => p.id === partnerId || p.partnerId === partnerId
//             );
//             if (listPartner) {
//                 setPartnerDetails(listPartner);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const refreshAllData = async () => {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             console.error("No auth token found");
//             return;
//         }
//         showLoader();
//         try {
//             const data = await getAllPartners(token);
//             setPartnersData(data);
//             if (selectedPartner) {
//                 const currentPartnerId = selectedPartner?.id || selectedPartner?.partnerId;
//                 if (currentPartnerId) {
//                     await fetchPartnerDetails(currentPartnerId);
//                 }
//             }
//         } catch (err) {
//             console.error("Refresh data error:", err);
//         } finally {
//             hideLoader();
//         }
//     };

//     const handleSaveRow = async (rowIndex) => {
//         const token = localStorage.getItem("authToken") || localStorage.getItem("token");
//         if (!token) {
//             alert("No authentication token found");
//             return;
//         }

//         try {
//             const partnerId = getCurrentPartnerId();
//             if (!partnerId) {
//                 console.error("Partner ID not found");
//                 return;
//             }

//             const row = rows[rowIndex];
//             const formData = new FormData();
//             const partnerData = {};

//             const fieldMapping = {
//                 "Full Name": "fullName",
//                 "Phone Number": "phoneNumber",
//                 "Email": "email",
//                 "AADHAR Number": "aadharNumber",
//                 "PAN Number": "panNumber",
//                 "License Number": "licenseNumber",
//                 "Vehicle Types": "vehicleTypes",
//                 "Vehicles": "vehicles",
//                 "Petrolium Types": "petroliumTypes",
//                 "RC Number": "rcNumber",
//                 "Insurance Number": "insuranceNumber",
//             };

//             const backendFieldName = fieldMapping[row.key];

//             if (backendFieldName && row.value && row.value !== "N/A") {
//                 if (Array.isArray(row.value)) {
//                     partnerData[backendFieldName] = row.value;
//                 } else if (typeof row.value === "string") {
//                     partnerData[backendFieldName] = row.value;
//                 }
//             }

//             if (row.key === "Current Address" && typeof row.value === "object") {
//                 Object.keys(row.value).forEach(key => {
//                     if (row.value[key] !== "N/A") {
//                         partnerData[key] = row.value[key];
//                     }
//                 });
//             }

//             if (row.key === "Permanent Address" && typeof row.value === "object") {
//                 Object.keys(row.value).forEach(key => {
//                     if (row.value[key] !== "N/A") {
//                         partnerData[key] = row.value[key];
//                     }
//                 });
//             }

//             if (row.key === "Bank Details" && typeof row.value === "object") {
//                 Object.keys(row.value).forEach(key => {
//                     if (row.value[key] !== "N/A") {
//                         partnerData[key] = row.value[key];
//                     }
//                 });
//             }

//             formData.append(
//                 "partnerData",
//                 new Blob([JSON.stringify(partnerData)], { type: "application/json" })
//             );

//             if (row.images && row.images.length > 0) {
//                 row.images.forEach((img, idx) => {
//                     if (img.file) {
//                         const imageFieldName = getImageFieldName(row.key, idx);
//                         formData.append(imageFieldName, img.file);
//                     }
//                 });
//             }

//             await updatePartnerDetails(partnerId, formData, token);
//             alert("Data updated successfully!");

//             setRows(prev =>
//                 prev.map((r, idx) =>
//                     idx === rowIndex ? { ...r, isEditing: false } : r
//                 )
//             );

//             fetchPartnerDetails(partnerId);

//         } catch (err) {
//             console.error("Error updating partner:", err);
//             alert("Error updating data: " + (err.response?.data?.message || err.message));
//         }
//     };

//     const getImageFieldName = (rowKey, imageIndex) => {
//         const fieldMap = {
//             "AADHAR Number": imageIndex === 0 ? "aadharCardFront" : "aadharCardBack",
//             "PAN Number": "panCard",
//             "License Number": imageIndex === 0 ? "licenseFront" : "licenseBack",
//             "Profile Picture": "profilePicture",
//             "RC Number": imageIndex === 0 ? "rcBookFront" : "rcBookBack",
//         };
//         return fieldMap[rowKey] || `image${imageIndex + 1}`;
//     };

//     useEffect(() => {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             console.error("No auth token found");
//             return;
//         }

//         const fetchPartners = async () => {
//             try {
//                 showLoader();
//                 const data = await getAllDeliveryPartners(token);
//                 setPartnersData(data);
//             } catch (err) {
//                 console.error("Partners fetch error:", err);
//             } finally {
//                 hideLoader();
//             }
//         };

//         fetchPartners();
//     }, [refreshKey]);

//     // Combined filter with search
//     const searchFilteredData = useMemo(() => {
//         let data = partnersData;

//         if (vehicleFilter) {
//             data = data.filter((i) =>
//                 i.vehicleTypes?.includes(vehicleFilter) ||
//                 i.vehicles?.includes(vehicleFilter)
//             );
//         }

//         if (cityFilter) {
//             data = data.filter((i) => i.city?.toLowerCase().includes(cityFilter.toLowerCase()));
//         }

//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             data = data.filter(partner => {
//                 let fieldValue;

//                 if (searchType === "phoneNumber") {
//                     fieldValue = partner.phoneNumber || partner.maskedPhoneNumber;
//                 } else if (searchType === "email") {
//                     fieldValue = partner.email || partner.maskedEmail;
//                 } else {
//                     fieldValue = partner[searchType];
//                 }

//                 if (!fieldValue) return false;

//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }
//         // Sort Partner IDs in Descending Order
//         // Sort Partner IDs in Descending Order
//         const sortedData = [...data].sort((a, b) =>
//             String(b.partnerId || "").localeCompare(
//                 String(a.partnerId || ""),
//                 undefined,
//                 { numeric: true, sensitivity: "base" }
//             )
//         );

//         return sortedData;
//     }, [partnersData, searchQuery, searchType, vehicleFilter, cityFilter]);

//     useEffect(() => {
//         if (!selectedPartner) {
//             setRows(getDefaultDeliveryPartnerRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             setImageLoadErrors(new Set());
//             return;
//         }

//         const dataSource = partnerDetails || selectedPartner;

//         if (dataSource.verified === true) {
//             setIsApproved(true);
//         }

//         const imageMap = {
//             "AADHAR Number": [
//                 dataSource.aadharCardFront,
//                 dataSource.aadharCardBack
//             ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "PAN Number": [dataSource.panCard]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "License Number": [
//                 dataSource.licenseFront,
//                 dataSource.licenseBack
//             ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Profile Picture": [dataSource.profilePicture]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "RC Number": [
//                 dataSource.rcBookFront,
//                 dataSource.rcBookBack
//             ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//         };

//         const newRows = [
//             { key: "Full Name", value: dataSource.fullName || "N/A" },
//             { key: "Phone Number", value: dataSource.phoneNumber || "N/A" },
//             { key: "Email", value: dataSource.email || "N/A" },
//             { key: "Profile Picture", value: "Profile Picture" },
//             { key: "AADHAR Number", value: dataSource.aadharNumber || "N/A" },
//             { key: "PAN Number", value: dataSource.panNumber || "N/A" },
//             { key: "License Number", value: dataSource.licenseNumber || "N/A" },
//             {
//                 key: "Vehicle Types",
//                 value: Array.isArray(dataSource.vehicleTypes)
//                     ? dataSource.vehicleTypes
//                     : (dataSource.vehicleTypes ? [dataSource.vehicleTypes] : [])
//             },
//             {
//                 key: "Vehicles",
//                 value: Array.isArray(dataSource.vehicles)
//                     ? dataSource.vehicles
//                     : (dataSource.vehicles ? [dataSource.vehicles] : [])
//             },
//             {
//                 key: "Petrolium Types",
//                 value: Array.isArray(dataSource.petroliumTypes)
//                     ? dataSource.petroliumTypes
//                     : (dataSource.petroliumTypes ? [dataSource.petroliumTypes] : [])
//             },
//             {
//                 key: "RC Number",
//                 value: Array.isArray(dataSource.rcNumber) && dataSource.rcNumber.length > 0
//                     ? dataSource.rcNumber[0]
//                     : dataSource.rcNumber || "N/A"
//             },
//             {
//                 key: "Insurance Number",
//                 value: Array.isArray(dataSource.insuranceNumber) && dataSource.insuranceNumber.length > 0
//                     ? dataSource.insuranceNumber[0]
//                     : dataSource.insuranceNumber || "N/A"
//             },
//             {
//                 key: "Bank Details",
//                 value: {
//                     bankName: dataSource.bankName || "N/A",
//                     accountNumber: dataSource.accountNumber || "N/A",
//                     accountHolderName: dataSource.accountHolderName || "N/A",
//                     ifscCode: dataSource.ifscCode || "N/A",
//                     branchName: dataSource.branchName || "N/A",
//                     upiId: dataSource.upiId || "N/A",
//                 },
//             },
//             {
//                 key: "Current Address",
//                 value: {
//                     address: dataSource.address || "N/A",
//                     city: dataSource.city || "N/A",
//                     state: dataSource.state || "N/A",
//                     pinCode: dataSource.pinCode || "N/A",
//                     country: dataSource.country || "N/A",
//                     houseNo: dataSource.houseNo || "N/A",
//                     street: dataSource.street || "N/A",
//                 },
//             },
//             {
//                 key: "Permanent Address",
//                 value: {
//                     permanentAddress: dataSource.permanentAddress || "N/A",
//                     permanentCity: dataSource.permanentCity || "N/A",
//                     permanentState: dataSource.permanentState || "N/A",
//                     permanentPinCode: dataSource.permanentPinCode || "N/A",
//                     permanentCountry: dataSource.permanentCountry || "N/A",
//                     permanentHouseNo: dataSource.permanentHouseNo || "N/A",
//                     permanentStreet: dataSource.permanentStreet || "N/A",
//                 },
//             },
//         ];

//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key] || [],
//         }));

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setImageLoadErrors(new Set());
//     }, [selectedPartner, partnerDetails]);

//     const handleViewClick = (partner) => {
//         setSelectedPartner(partner);
//         const partnerId = partner?.id || partner?.partnerId;
//         fetchPartnerDetails(partnerId);
//     };

//     const handleVerifyy = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             console.warn("No status mapping for:", rows[i].key);
//             return;
//         }

//         const partnerId = getCurrentPartnerId();
//         if (!partnerId) return alert("Partner ID is missing");

//         try {
//             const updateData = { [statusField]: true };
//             const formData = new FormData();
//             formData.append(
//                 "partnerData",
//                 new Blob([JSON.stringify(updateData)], { type: "application/json" })
//             );

//             await verifyPartnerField(partnerId, formData, localStorage.getItem("authToken"));
//             await fetchPartnerDetails(partnerId);
//             alert("Partner field verified successfully!");
//         } catch (err) {
//             console.error("❌ Verify error:", err);
//             alert(`Failed to verify field: ${err.message}`);
//         }
//     };

//     const handleReject = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) return;

//         const partnerId = getCurrentPartnerId();
//         if (!partnerId) return alert("Partner ID is missing");

//         try {
//             const updateData = { [statusField]: false };
//             const formData = new FormData();
//             formData.append(
//                 "partnerData",
//                 new Blob([JSON.stringify(updateData)], { type: "application/json" })
//             );

//             await rejectPartnerField(partnerId, formData, localStorage.getItem("authToken"));
//             alert("Partner field rejected successfully!");
//             fetchPartnerDetails(partnerId);
//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             alert(`Failed to reject field: ${err.message}`);
//         }
//     };

//     const handleApproveAll = async () => {
//         const partnerId = getCurrentPartnerId();
//         if (!partnerId) {
//             alert("Partner ID is missing");
//             return;
//         }

//         setIsApproving(true);

//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) {
//                 alert("Authorization token missing");
//                 return;
//             }

//             const payload = { rejectReason: "", verified: true };
//             const data = await approvePartner(partnerId, payload, token);

//             if (data) {
//                 alert("✅ Partner approved successfully!");
//                 setPartnerDetails(prev => ({ ...prev, ...data, verified: true }));
//                 setSelectedPartner(prev => ({ ...prev, ...data, verified: true }));
//                 setPartnersData(prev =>
//                     prev.map(partner =>
//                         partner.id === partnerId || partner.partnerId === partnerId
//                             ? { ...partner, ...data, verified: true }
//                             : partner
//                     )
//                 );
//                 setIsApproved(true);
//                 setTimeout(() => setRefreshKey(prev => prev + 1), 1000);
//             } else {
//                 alert("⚠️ Approval failed. Empty response from backend.");
//             }
//         } catch (err) {
//             console.error("❌ Approve partner error:", err);
//             const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message;
//             alert(`Failed to approve partner: ${errorMessage}`);
//         } finally {
//             setIsApproving(false);
//         }
//     };

//     const handleRejectAll = async () => {
//         if (!rejectionDescription.trim()) {
//             alert("Please enter a rejection reason");
//             return;
//         }

//         const partnerId = getCurrentPartnerId();
//         if (!partnerId) return alert("Partner ID is missing");

//         setIsRejecting(true);

//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) return alert("Authorization token missing");

//             const requestBody = {
//                 verified: false,
//                 rejectReason: rejectionDescription.trim()
//             };

//             const data = await rejectPartnerApproval(partnerId, requestBody, token);

//             setShowRejectDropdown(false);
//             setRejectionDescription("");

//             if (data) {
//                 alert("Partner verification rejected successfully!");
//                 setPartnersData(prev =>
//                     prev.map(partner =>
//                         partner.id === partnerId || partner.partnerId === partnerId
//                             ? { ...partner, verified: false, rejectReason: rejectionDescription }
//                             : partner
//                     )
//                 );
//                 setPartnerDetails(prev => ({ ...prev, verified: false, rejectReason: rejectionDescription }));
//                 setSelectedPartner(prev => ({ ...prev, verified: false, rejectReason: rejectionDescription }));
//                 setIsApproved(false);
//                 setTimeout(() => setRefreshKey(prev => prev + 1), 1000);
//             } else {
//                 throw new Error("Invalid response from server");
//             }
//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message || "Failed to reject partner";
//             alert(`Failed to reject: ${errorMessage}`);
//         } finally {
//             setIsRejecting(false);
//         }
//     };

//     const handleBackClick = () => setSelectedPartner(null);

//     const handleExportFiltered = () => {
//         const exportData = searchFilteredData.length > 0 ? searchFilteredData : partnersData;

//         if (exportData.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO", "Partner ID", "Full Name", "Email", "Phone Number",
//             "City", "Vehicle Types", "Verified Status", "Online Status"
//         ];

//         const csvRows = exportData.map((partner, index) => [
//             index + 1,
//             partner.partnerId || 'N/A',
//             partner.fullName || 'N/A',
//             partner.email || partner.maskedEmail || 'N/A',
//             partner.phoneNumber || partner.maskedPhoneNumber || 'N/A',
//             partner.city || 'N/A',
//             Array.isArray(partner.vehicleTypes) ? partner.vehicleTypes.join(", ") : 'N/A',
//             partner.verified ? "Verified" : "Pending",
//             partner.online ? "Online" : "Offline"
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "subscribed_logistics_partners.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     const ImageDisplay = ({ images, fieldName }) => {
//         if (!images || images.length === 0) {
//             return (
//                 <div className="text-center">
//                     <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
//                 </div>
//             );
//         }

//         return (
//             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                 {images.map((img, idx) => {
//                     const imageUrl = typeof img === 'string' ? img : img.url;
//                     const hasFailed = isImageFailed(fieldName, idx);

//                     if (hasFailed || !imageUrl) {
//                         return (
//                             <div key={idx} className="text-center">
//                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
//                             </div>
//                         );
//                     }

//                     return (
//                         <div key={idx} className="text-center position-relative">
//                             <img
//                                 src={imageUrl}
//                                 alt={`${fieldName}-${idx}`}
//                                 style={{
//                                     width: fieldName === "Profile Picture" ? "80px" : "60px",
//                                     height: fieldName === "Profile Picture" ? "80px" : "60px",
//                                     borderRadius: "8px",
//                                     objectFit: "cover",
//                                     border: "2px solid #e2e8f0",
//                                     transition: "transform 0.2s ease"
//                                 }}
//                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
//                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
//                             />
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     // Calculate stats
//     const totalPartners = partnersData.length;
//     const verifiedCount = partnersData.filter(p => p.verified === true).length;
//     const pendingCount = partnersData.filter(p => p.verified !== true).length;
//     const onlineCount = partnersData.filter(p => p.online === true).length;

//     return (
//         <div style={styles.container}>
//             {!selectedPartner ? (
//                 <>



//                     {/* Filters */}
//                     <div style={styles.filtersContainer}>
//                         <div style={styles.searchGroup}>
//                             <select
//                                 value={searchType}
//                                 onChange={(e) => setSearchType(e.target.value)}
//                                 style={styles.select}
//                             >
//                                 {searchOptions.map(option => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>

//                             <input
//                                 type="text"
//                                 placeholder={getPlaceholderText()}
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 style={{
//                                     ...styles.input,
//                                     borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
//                                 }}
//                             />
//                         </div>

//                         <select
//                             value={vehicleFilter}
//                             onChange={(e) => setVehicleFilter(e.target.value)}
//                             style={{ ...styles.select, minWidth: '110px' }}
//                         >
//                             <option value="">All Vehicles</option>
//                             {vehicleTypeOptions.map(option => (
//                                 <option key={option} value={option}>{option}</option>
//                             ))}
//                         </select>

//                         <button
//                             onClick={clearAllFilters}
//                             style={{ ...styles.button, ...styles.buttonSecondary }}
//                         >
//                             <Icons.Clear /> Clear
//                         </button>

//                         <button
//                             onClick={handleExportFiltered}
//                             style={{ ...styles.button, ...styles.buttonPrimary }}
//                         >
//                             <Icons.Export /> Export
//                         </button>
//                     </div>

//                     {/* Table */}
//                     <div style={styles.tableWrapper}>
//                         <table style={styles.table}>
//                             <thead style={styles.thead}>
//                                 <tr>
//                                     <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
//                                     <th style={styles.th}>Partner ID</th>
//                                     <th style={styles.th}>Full Name</th>
//                                     <th style={styles.th}>Email</th>
//                                     <th style={styles.th}>Mobile</th>
//                                     <th style={styles.th}>City</th>


//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {searchFilteredData.length ? (
//                                     searchFilteredData.map((partner, idx) => (
//                                         <tr
//                                             key={partner.id || idx}
//                                             style={{
//                                                 backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                                 transition: 'background 0.15s ease'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#fafbfc'}
//                                         >
//                                             <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>{idx + 1}</td>
//                                             <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
//                                                 {partner?.partnerId || "—"}
//                                             </td>
//                                             <td style={{ ...styles.td, fontWeight: '500' }}>
//                                                 {partner?.fullName || "—"}
//                                             </td>
//                                             <td style={{ ...styles.td, color: '#4a5568' }}>
//                                                 {partner?.maskedEmail || partner?.email || "—"}
//                                             </td>
//                                             <td style={styles.td}>
//                                                 {partner?.maskedPhoneNumber || partner?.phoneNumber || "—"}
//                                             </td>
//                                             <td style={styles.td}>
//                                                 {partner?.city || "—"}
//                                             </td>


//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan="9" style={{ padding: 0 }}>
//                                             <div style={styles.emptyState}>
//                                                 <Icons.NoData />
//                                                 <div style={styles.emptyStateText}>
//                                                     {partnersData.length === 0 ? 'Loading partners...' : 'No partners found'}
//                                                 </div>
//                                                 <div style={styles.emptyStateSubtext}>
//                                                     {partnersData.length === 0
//                                                         ? 'Please wait while we fetch the data'
//                                                         : (searchQuery.trim() || vehicleFilter || cityFilter)
//                                                             ? 'Try adjusting your filters to see more results'
//                                                             : 'No subscribed logistics partners are available'}
//                                                 </div>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </>
//             ) : (
//                 /* ============ DETAIL VIEW ============ */
//                 <div>
//                     {/* Detail Header */}
//                     <div style={styles.detailHeader}>
//                         <button
//                             onClick={handleBackClick}
//                             style={{ ...styles.button, ...styles.buttonPrimary }}
//                         >
//                             <Icons.Back /> Back
//                         </button>
//                         <div style={styles.detailTitle}>
//                             Partner Details — <span style={{ color: 'rgb(230 109 51)' }}>
//                                 {selectedPartner?.fullName || 'N/A'}
//                             </span>
//                         </div>
//                         {partnerDetails?.verified === true || isApproved ? (
//                             <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
//                                 <Icons.Approved /> Approved
//                             </span>
//                         ) : (
//                             <span style={{ ...styles.statusBadge, ...styles.statusPending }}>
//                                 <Icons.Offline /> Pending
//                             </span>
//                         )}
//                         <button
//                             onClick={refreshAllData}
//                             style={{ ...styles.button, ...styles.buttonSecondary }}
//                         >
//                             <Icons.Refresh /> Refresh
//                         </button>
//                     </div>

//                     {loading && (
//                         <div className="text-center my-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                         </div>
//                     )}

//                     {!loading && (
//                         <>
//                             <div style={styles.detailTableWrapper}>
//                                 <table style={styles.detailTable}>
//                                     <thead>
//                                         <tr>
//                                             <th style={styles.detailTh}>Field</th>
//                                             <th style={styles.detailTh}>Value</th>
//                                             <th style={styles.detailTh}>Image</th>
//                                             <th style={styles.detailTh}>Status</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {rows.map((r, i) => {
//                                             const isEditing = r.isEditing || false;

//                                             const handleInputChange = (field, value) => {
//                                                 setRows((prevRows) =>
//                                                     prevRows.map((row, idx) =>
//                                                         idx === i
//                                                             ? {
//                                                                 ...row,
//                                                                 value:
//                                                                     typeof row.value === "object"
//                                                                         ? { ...row.value, [field]: value }
//                                                                         : value,
//                                                             }
//                                                             : row
//                                                     )
//                                                 );
//                                             };

//                                             const handleArraySelection = (selectedValue) => {
//                                                 setRows((prevRows) =>
//                                                     prevRows.map((row, idx) => {
//                                                         if (idx === i) {
//                                                             const currentValues = Array.isArray(row.value) ? row.value : [];
//                                                             const isSelected = currentValues.includes(selectedValue);

//                                                             if (isSelected) {
//                                                                 return {
//                                                                     ...row,
//                                                                     value: currentValues.filter(v => v !== selectedValue)
//                                                                 };
//                                                             } else {
//                                                                 return {
//                                                                     ...row,
//                                                                     value: [...currentValues, selectedValue]
//                                                                 };
//                                                             }
//                                                         }
//                                                         return row;
//                                                     })
//                                                 );
//                                             };

//                                             const handleImageChange = (e) => {
//                                                 const files = Array.from(e.target.files);
//                                                 const newImages = files.map((file) => ({
//                                                     url: URL.createObjectURL(file),
//                                                     file
//                                                 }));

//                                                 setRows(prev =>
//                                                     prev.map((row, idx) =>
//                                                         idx === i
//                                                             ? {
//                                                                 ...row,
//                                                                 images: [...(row.images || []), ...newImages]
//                                                             }
//                                                             : row
//                                                     )
//                                                 );
//                                             };

//                                             const getOptions = () => {
//                                                 switch (r.key) {
//                                                     case "Vehicle Types": return vehicleTypeOptions;
//                                                     case "Vehicles": return vehiclesOptions;
//                                                     case "Petrolium Types": return petroliumTypeOptions;
//                                                     default: return [];
//                                                 }
//                                             };

//                                             return (
//                                                 <tr key={r.key || i}>
//                                                     <td style={{ ...styles.detailTd, fontWeight: '600' }}>{r.key}</td>

//                                                     <td style={styles.detailTd}>
//                                                         {r.key === "Vehicle Types" || r.key === "Vehicles" || r.key === "Petrolium Types" ? (
//                                                             isEditing ? (
//                                                                 <div className="d-flex flex-column gap-1">
//                                                                     {getOptions().map((option) => {
//                                                                         const currentValues = Array.isArray(r.value) ? r.value : [];
//                                                                         const isSelected = currentValues.includes(option);

//                                                                         return (
//                                                                             <div key={option} className="form-check">
//                                                                                 <input
//                                                                                     className="form-check-input"
//                                                                                     type="checkbox"
//                                                                                     id={`${r.key}-${option}-${i}`}
//                                                                                     checked={isSelected}
//                                                                                     onChange={() => handleArraySelection(option)}
//                                                                                 />
//                                                                                 <label
//                                                                                     className="form-check-label"
//                                                                                     htmlFor={`${r.key}-${option}-${i}`}
//                                                                                 >
//                                                                                     {option}
//                                                                                 </label>
//                                                                             </div>
//                                                                         );
//                                                                     })}
//                                                                 </div>
//                                                             ) : (
//                                                                 Array.isArray(r.value) && r.value.length > 0
//                                                                     ? r.value.join(", ")
//                                                                     : "N/A"
//                                                             )
//                                                         ) : r.key === "Bank Details" ? (
//                                                             Object.entries(r.value || {}).map(([field, value]) => (
//                                                                 <div key={field} className="mb-1">
//                                                                     <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
//                                                                     {isEditing ? (
//                                                                         <input
//                                                                             type="text"
//                                                                             value={value || ""}
//                                                                             onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                             className="form-control d-inline-block w-75"
//                                                                         />
//                                                                     ) : (
//                                                                         safeDisplay(value)
//                                                                     )}
//                                                                 </div>
//                                                             ))
//                                                         ) : r.key === "Current Address" || r.key === "Permanent Address" ? (
//                                                             Object.entries(r.value || {}).map(([field, value]) => (
//                                                                 <div key={field} className="mb-1">
//                                                                     <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
//                                                                     {isEditing ? (
//                                                                         <input
//                                                                             type="text"
//                                                                             value={value || ""}
//                                                                             onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                             className="form-control d-inline-block w-75"
//                                                                         />
//                                                                     ) : (
//                                                                         safeDisplay(value)
//                                                                     )}
//                                                                 </div>
//                                                             ))
//                                                         ) : r.key === "Profile Picture" ? (
//                                                             "Profile Picture"
//                                                         ) : r.key === "RC Number" || r.key === "Insurance Number" ? (
//                                                             isEditing ? (
//                                                                 <input
//                                                                     type="text"
//                                                                     value={r.value || ""}
//                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                     className="form-control"
//                                                                 />
//                                                             ) : (
//                                                                 safeDisplay(r.value)
//                                                             )
//                                                         ) : (
//                                                             isEditing ? (
//                                                                 <input
//                                                                     type="text"
//                                                                     value={r.value || ""}
//                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                     className="form-control"
//                                                                 />
//                                                             ) : (
//                                                                 safeDisplay(r.value)
//                                                             )
//                                                         )}
//                                                     </td>

//                                                     <td style={{ ...styles.detailTd, textAlign: 'center' }}>
//                                                         {isEditing ? (
//                                                             <>
//                                                                 <input
//                                                                     type="file"
//                                                                     multiple={r.key === "AADHAR Number" || r.key === "License Number" || r.key === "RC Number"}
//                                                                     accept="image/*"
//                                                                     onChange={handleImageChange}
//                                                                     className="form-control mb-2"
//                                                                 />
//                                                                 <ImageDisplay images={r.images} fieldName={r.key} />
//                                                             </>
//                                                         ) : (
//                                                             <ImageDisplay images={r.images} fieldName={r.key} />
//                                                         )}
//                                                     </td>

//                                                     <td style={{ ...styles.detailTd, textAlign: 'center' }}>
//                                                         {isEditing ? (
//                                                             <div className="d-flex flex-wrap gap-2 justify-content-center">
//                                                                 <button
//                                                                     className="btn btn-sm btn-success"
//                                                                     onClick={() => handleSaveRow(i)}
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     <Icons.Save /> Save
//                                                                 </button>
//                                                                 <button
//                                                                     className="btn btn-sm btn-secondary"
//                                                                     onClick={() =>
//                                                                         setRows((prev) =>
//                                                                             prev.map((row, idx) =>
//                                                                                 idx === i ? { ...row, isEditing: false } : row
//                                                                             )
//                                                                         )
//                                                                     }
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     Cancel
//                                                                 </button>
//                                                             </div>
//                                                         ) : (
//                                                             <div className="d-flex flex-wrap gap-2 justify-content-center">
//                                                                 {isFieldVerified(r.key, r.value, partnerDetails) ? (
//                                                                     <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
//                                                                         <Icons.Check /> Verified
//                                                                     </span>
//                                                                 ) : (
//                                                                     <button
//                                                                         className="btn btn-sm btn-warning"
//                                                                         onClick={() => handleVerifyy(i)}
//                                                                         disabled={
//                                                                             isFieldVerified(r.key, r.value, partnerDetails) ||
//                                                                             isFieldRejected(r.key, partnerDetails)
//                                                                         }
//                                                                         style={{ minWidth: 70 }}
//                                                                     >
//                                                                         Verify
//                                                                     </button>
//                                                                 )}

//                                                                 {isFieldRejected(r.key, partnerDetails) ? (
//                                                                     <span style={{ ...styles.statusBadge, ...styles.statusOffline }}>
//                                                                         <Icons.X /> Rejected
//                                                                     </span>
//                                                                 ) : (
//                                                                     <button
//                                                                         className="btn btn-sm btn-secondary"
//                                                                         onClick={() => handleReject(i)}
//                                                                         disabled={
//                                                                             isFieldRejected(r.key, partnerDetails) ||
//                                                                             isFieldVerified(r.key, r.value, partnerDetails)
//                                                                         }
//                                                                         style={{ minWidth: 70 }}
//                                                                     >
//                                                                         Reject
//                                                                     </button>
//                                                                 )}

//                                                                 <button
//                                                                     className="btn btn-sm btn-primary"
//                                                                     onClick={() =>
//                                                                         setRows((prev) =>
//                                                                             prev.map((row, idx) =>
//                                                                                 idx === i ? { ...row, isEditing: true } : row
//                                                                             )
//                                                                         )
//                                                                     }
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     <Icons.Edit /> Edit
//                                                                 </button>
//                                                             </div>
//                                                         )}
//                                                     </td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>

//                             {/* Approval Section */}
//                             <div style={styles.approvalContainer}>
//                                 {partnerDetails?.verified === true || isApproved ? (
//                                     <span style={{ ...styles.statusBadge, ...styles.statusVerified, fontSize: '14px', padding: '6px 20px' }}>
//                                         <Icons.Approved /> Approved ✓
//                                     </span>
//                                 ) : (
//                                     <>
//                                         <button
//                                             className="btn btn-success px-4 py-2 fw-bold"
//                                             style={{ minWidth: "120px" }}
//                                             onClick={handleApproveAll}
//                                             disabled={isApproving || isRejecting}
//                                         >
//                                             {isApproving ? (
//                                                 <>
//                                                     <span className="spinner-border spinner-border-sm me-2"></span>
//                                                     Approving...
//                                                 </>
//                                             ) : (
//                                                 "Approve"
//                                             )}
//                                         </button>

//                                         <div className="position-relative">
//                                             {showRejectDropdown ? (
//                                                 <div style={styles.rejectCard}>
//                                                     <div className="mb-3">
//                                                         <label className="form-label fw-bold">Rejection Reason</label>
//                                                         <textarea
//                                                             className="form-control"
//                                                             rows="3"
//                                                             placeholder="Enter rejection reason..."
//                                                             value={rejectionDescription}
//                                                             onChange={(e) => setRejectionDescription(e.target.value)}
//                                                             disabled={isApproving || isRejecting}
//                                                         />
//                                                     </div>
//                                                     <div className="d-flex gap-2">
//                                                         <button
//                                                             className="btn btn-danger flex-grow-1"
//                                                             onClick={handleRejectAll}
//                                                             disabled={!rejectionDescription.trim() || isApproving || isRejecting}
//                                                         >
//                                                             {isRejecting ? (
//                                                                 <>
//                                                                     <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                     Rejecting...
//                                                                 </>
//                                                             ) : (
//                                                                 "Confirm Reject"
//                                                             )}
//                                                         </button>
//                                                         <button
//                                                             className="btn btn-secondary"
//                                                             onClick={() => {
//                                                                 setShowRejectDropdown(false);
//                                                                 setRejectionDescription("");
//                                                             }}
//                                                             disabled={isApproving || isRejecting}
//                                                         >
//                                                             Cancel
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 <button
//                                                     className="btn btn-danger px-4 py-2 fw-bold"
//                                                     style={{ minWidth: "120px" }}
//                                                     onClick={() => setShowRejectDropdown(true)}
//                                                     disabled={isApproving || isRejecting}
//                                                 >
//                                                     {isRejecting ? (
//                                                         <>
//                                                             <span className="spinner-border spinner-border-sm me-2"></span>
//                                                             Rejecting...
//                                                         </>
//                                                     ) : (
//                                                         "Reject"
//                                                     )}
//                                                 </button>
//                                             )}
//                                         </div>
//                                     </>
//                                 )}
//                             </div>
//                         </>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Logisticssubscribedclients;


import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getPartnerDetails, getAllPartners, updatePartnerDetails, getAllDeliveryPartners,
    verifyPartnerField, rejectPartnerField,
    approvePartner, rejectPartnerApproval
} from "../../../Servicefile/clientManagementService.jsx";
import { Calendar, ChevronDown } from "lucide-react";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Back: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
        </svg>
    ),
    Edit: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Save: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    Approved: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Online: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
        </svg>
    ),
    Offline: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="8" y1="8" x2="16" y2="16" />
            <line x1="16" y1="8" x2="8" y2="16" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Truck: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <rect x="1" y="3" width="15" height="13" />
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
            <circle cx="5.5" cy="18" r="2.5" />
            <circle cx="18.5" cy="18" r="2.5" />
        </svg>
    ),
    Users: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
    ),
    CheckCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    ),
    XCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
    ),
    Clock: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    Today: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
            <circle cx="12" cy="15" r="1"/>
            <circle cx="16" cy="15" r="1"/>
            <circle cx="8" cy="15" r="1"/>
        </svg>
    )
};

// Date filter options
const dateFilterOptions = ["All", "Today", "Yesterday", "This Week", "This Month", "Last Month", "This Year", "Custom Range"];

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        minHeight: '500px'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '12px',
        marginTop: '12px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '12px 16px',
        border: '1px solid #edf2f7',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.2s ease'
    },
    statCardLeft: {
        display: 'flex',
        flexDirection: 'column'
    },
    statCardLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#94a3b8',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    statCardValue: {
        fontSize: '22px',
        fontWeight: '700',
        color: '#0f172a',
        marginTop: '2px',
        lineHeight: '1.2'
    },
    statCardIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 12px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 0 12px 0',
       
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '180px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    buttonWarning: {
        background: '#ecc94b',
        color: '#744210'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        height: '38px',
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    dateFilterBtnActive: {
        borderColor: '#e66d33',
        color: '#e66d33'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1000px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: '#e66d33',
        borderBottom: '2px solid #edf2f7',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusOnline: {
        background: '#bee3f8',
        color: '#2a4365'
    },
    statusOffline: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusVerified: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    detailHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 0',
        borderBottom: '2px solid #e9ecef',
        marginBottom: '16px',
        flexWrap: 'wrap'
    },
    detailTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#2d3748',
        flex: 1
    },
    detailTableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '550px'
    },
    detailTable: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '700px'
    },
    detailTh: {
        padding: '10px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        border: '1px solid #dee2e6'
    },
    detailTd: {
        padding: '10px 14px',
        border: '1px solid #dee2e6',
        verticalAlign: 'middle',
        fontSize: '13px'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    approvalContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
        padding: '20px 0',
        marginTop: '16px',
        borderTop: '2px solid #e9ecef',
        flexWrap: 'wrap'
    },
    rejectCard: {
        padding: '16px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        width: '320px',
        position: 'absolute',
        top: 'calc(100% + 8px)',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        border: '1px solid #e2e8f0'
    }
};

// ============================================
// HELPER FUNCTIONS
// ============================================
const getDefaultDeliveryPartnerRows = () => [
    { key: "Full Name", value: "", isUpload: false },
    { key: "Phone Number", value: "", isUpload: false },
    { key: "Email", value: "", isUpload: false },
    { key: "Profile Picture", value: null, isUpload: false },
    { key: "AADHAR Number", value: "", isUpload: false },
    { key: "PAN Number", value: "", isUpload: false },
    { key: "License Number", value: "", isUpload: false },
    { key: "Vehicle Types", value: [], isUpload: false },
    { key: "Vehicles", value: [], isUpload: false },
    { key: "Petrolium Types", value: [], isUpload: false },
    { key: "RC Number", value: "", isUpload: false },
    { key: "Insurance Number", value: "", isUpload: false },
    {
        key: "Bank Details", value: {
            bankName: "",
            accountNumber: "",
            accountHolderName: "",
            ifscCode: "",
            branchName: "",
            upiId: ""
        }, isUpload: false
    },
    {
        key: "Current Address", value: {
            address: "",
            city: "",
            state: "",
            pinCode: "",
            country: "",
            houseNo: "",
            street: ""
        }, isUpload: false
    },
    {
        key: "Permanent Address", value: {
            permanentAddress: "",
            permanentCity: "",
            permanentState: "",
            permanentPinCode: "",
            permanentCountry: "",
            permanentHouseNo: "",
            permanentStreet: ""
        }, isUpload: false
    }
];

const vehicleTypeOptions = ["BIKE", "PASSENGER_AUTO", "CAR", "MINI_TRUCK", "TRUCK"];
const vehiclesOptions = ["TwoWheeler", "ThreeWheeler", "FourWheeler", "HeavyVehicle"];
const petroliumTypeOptions = ["PETROL", "DIESEL", "CNG", "ELECTRIC"];

const STATUS_FIELD_MAP = {
    "Full Name": "fullNameStatus",
    "Phone Number": "phoneNumberStatus",
    "Email": "emailStatus",
    "Profile Picture": "profilePictureStatus",
    "AADHAR Number": "aadharNumberStatus",
    "PAN Number": "panNumberStatus",
    "License Number": "licenseNumberStatus",
    "Vehicle Types": "vehicleTypesStatus",
    "Vehicles": "vehiclesStatus",
    "Petrolium Types": "petroliumTypesStatus",
    "RC Number": "rcNumberStatus",
    "Insurance Number": "insuranceNumberStatus",
    "Bank Details": "bankDetailsStatus",
    "Current Address": "addressStatus",
    "Permanent Address": "permanentAddressStatus"
};

const safeDisplay = (value) => {
    if (value === null || value === undefined) return "N/A";
    if (typeof value === 'string' && value.trim() === "") return "N/A";
    if (value === "N/A" || value === "Invalid Date") return "N/A";
    return value;
};

const hasValidData = (row, partnerDetails) => {
    if (!row || !partnerDetails) return false;
    const field = row.key;
    const value = row.value;

    if (typeof value === 'string') {
        return value && value !== "N/A" && value.trim() !== "";
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.some(item => item && item !== "N/A");
    }
    if (typeof value === 'object') {
        return Object.values(value).some(val => {
            if (val === null || val === undefined) return false;
            if (typeof val === 'string') return val.trim() !== "" && val !== "N/A";
            if (Array.isArray(val)) return val.length > 0;
            return true;
        });
    }
    return false;
};

const isFieldVerified = (rowKey, rowValue, partnerDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];
    if (!statusField || !partnerDetails) return false;
    if (partnerDetails[statusField] === true) return true;
    if ((partnerDetails[statusField] === null || partnerDetails[statusField] === undefined) &&
        hasValidData({ key: rowKey, value: rowValue }, partnerDetails)) {
        return true;
    }
    return false;
};

const isFieldRejected = (rowKey, partnerDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];
    if (!statusField || !partnerDetails) return false;
    return partnerDetails[statusField] === false;
};

// ============================================
// MAIN COMPONENT
// ============================================
const Logisticssubscribedclients = () => {
    /* -------- list‑screen state -------- */
    const [partnersData, setPartnersData] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [vehicleFilter, setVehicleFilter] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const { showLoader, hideLoader } = useLoader();

    /* -------- detail‑screen state -------- */
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [partnerDetails, setPartnerDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState(getDefaultDeliveryPartnerRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

    const fileInputRef = useRef(null);
    const [partnerData, setPartnerData] = useState({});
    const [rowId, setRowId] = useState(null);

    const [showRejectDropdown, setShowRejectDropdown] = useState(false);
    const [rejectionDescription, setRejectionDescription] = useState("");

    const [isApproving, setIsApproving] = useState(false);
    const [isRejecting, setIsRejecting] = useState(false);

    const [refreshKey, setRefreshKey] = useState(0);

    // Date filter states - Default "Today"
    const [selectedDateFilter, setSelectedDateFilter] = useState("All");
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [customFromDate, setCustomFromDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [showCustomPicker, setShowCustomPicker] = useState(false);
    const dateDropdownRef = useRef(null);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        verified: 0,
        pending: 0,
        online: 0,
        todayRiders: 0
    });

    // Search filters
    const [searchType, setSearchType] = useState("partnerId");
    const [searchQuery, setSearchQuery] = useState("");

    const searchOptions = [
        { value: "partnerId", label: "Partner ID" },
        { value: "fullName", label: "Full Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" }
    ];

    const getCurrentPartnerId = () => {
        return (
            selectedPartner?.id ||
            selectedPartner?.partnerId ||
            partnerDetails?.id ||
            null
        );
    };

    const partnerId = getCurrentPartnerId();

    const getPlaceholderText = () => {
        switch (searchType) {
            case "partnerId": return "Search by Partner ID...";
            case "fullName": return "Search by Full Name...";
            case "email": return "Search by Email...";
            case "phoneNumber": return "Search by Mobile...";
            case "city": return "Search by City...";
            default: return "Search...";
        }
    };

    const clearAllFilters = () => {
        setSearchQuery("");
        setVehicleFilter("");
        setCityFilter("");
        setStatusFilter("");
        setSelectedDateFilter("Today");
        setCustomFromDate(new Date().toISOString().split('T')[0]);
        setCustomToDate(new Date().toISOString().split('T')[0]);
    };

    // Close date dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
                setShowDateDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleImageError = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => new Set([...prev, errorKey]));
    };

    const handleImageLoad = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => {
            const newSet = new Set(prev);
            newSet.delete(errorKey);
            return newSet;
        });
    };

    const isImageFailed = (fieldName, index) => {
        return imageLoadErrors.has(`${fieldName}-${index}`);
    };

    const fetchPartnerDetails = async (partnerId) => {
        if (!partnerId) return;
        setLoading(true);
        const token = localStorage.getItem("authToken");

        try {
            const data = await getPartnerDetails(partnerId, token);
            setPartnerDetails(data);
        } catch (err) {
            console.error("❌ get-partner-details error:", err);
            const listPartner = partnersData.find(
                p => p.id === partnerId || p.partnerId === partnerId
            );
            if (listPartner) {
                setPartnerDetails(listPartner);
            }
        } finally {
            setLoading(false);
        }
    };

    const refreshAllData = async () => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            console.error("No auth token found");
            return;
        }
        showLoader();
        try {
            const data = await getAllPartners(token);
            setPartnersData(data);
            if (selectedPartner) {
                const currentPartnerId = selectedPartner?.id || selectedPartner?.partnerId;
                if (currentPartnerId) {
                    await fetchPartnerDetails(currentPartnerId);
                }
            }
        } catch (err) {
            console.error("Refresh data error:", err);
        } finally {
            hideLoader();
        }
    };

    const handleSaveRow = async (rowIndex) => {
        const token = localStorage.getItem("authToken") || localStorage.getItem("token");
        if (!token) {
            alert("No authentication token found");
            return;
        }

        try {
            const partnerId = getCurrentPartnerId();
            if (!partnerId) {
                console.error("Partner ID not found");
                return;
            }

            const row = rows[rowIndex];
            const formData = new FormData();
            const partnerData = {};

            const fieldMapping = {
                "Full Name": "fullName",
                "Phone Number": "phoneNumber",
                "Email": "email",
                "AADHAR Number": "aadharNumber",
                "PAN Number": "panNumber",
                "License Number": "licenseNumber",
                "Vehicle Types": "vehicleTypes",
                "Vehicles": "vehicles",
                "Petrolium Types": "petroliumTypes",
                "RC Number": "rcNumber",
                "Insurance Number": "insuranceNumber",
            };

            const backendFieldName = fieldMapping[row.key];

            if (backendFieldName && row.value && row.value !== "N/A") {
                if (Array.isArray(row.value)) {
                    partnerData[backendFieldName] = row.value;
                } else if (typeof row.value === "string") {
                    partnerData[backendFieldName] = row.value;
                }
            }

            if (row.key === "Current Address" && typeof row.value === "object") {
                Object.keys(row.value).forEach(key => {
                    if (row.value[key] !== "N/A") {
                        partnerData[key] = row.value[key];
                    }
                });
            }

            if (row.key === "Permanent Address" && typeof row.value === "object") {
                Object.keys(row.value).forEach(key => {
                    if (row.value[key] !== "N/A") {
                        partnerData[key] = row.value[key];
                    }
                });
            }

            if (row.key === "Bank Details" && typeof row.value === "object") {
                Object.keys(row.value).forEach(key => {
                    if (row.value[key] !== "N/A") {
                        partnerData[key] = row.value[key];
                    }
                });
            }

            formData.append(
                "partnerData",
                new Blob([JSON.stringify(partnerData)], { type: "application/json" })
            );

            if (row.images && row.images.length > 0) {
                row.images.forEach((img, idx) => {
                    if (img.file) {
                        const imageFieldName = getImageFieldName(row.key, idx);
                        formData.append(imageFieldName, img.file);
                    }
                });
            }

            await updatePartnerDetails(partnerId, formData, token);
            alert("Data updated successfully!");

            setRows(prev =>
                prev.map((r, idx) =>
                    idx === rowIndex ? { ...r, isEditing: false } : r
                )
            );

            fetchPartnerDetails(partnerId);

        } catch (err) {
            console.error("Error updating partner:", err);
            alert("Error updating data: " + (err.response?.data?.message || err.message));
        }
    };

    const getImageFieldName = (rowKey, imageIndex) => {
        const fieldMap = {
            "AADHAR Number": imageIndex === 0 ? "aadharCardFront" : "aadharCardBack",
            "PAN Number": "panCard",
            "License Number": imageIndex === 0 ? "licenseFront" : "licenseBack",
            "Profile Picture": "profilePicture",
            "RC Number": imageIndex === 0 ? "rcBookFront" : "rcBookBack",
        };
        return fieldMap[rowKey] || `image${imageIndex + 1}`;
    };

    // Get date range from selection
    const getDateRangeFromSelection = () => {
        if (selectedDateFilter === "All") return null;

        const today = new Date();
        let from = new Date();
        let to = new Date();

        switch (selectedDateFilter) {
            case "Today":
                from = today;
                to = today;
                break;
            case "Yesterday":
                from.setDate(today.getDate() - 1);
                to.setDate(today.getDate() - 1);
                break;
            case "This Week": {
                const day = today.getDay();
                from.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
                to = new Date(from);
                to.setDate(from.getDate() + 6);
                break;
            }
            case "This Month":
                from = new Date(today.getFullYear(), today.getMonth(), 1);
                to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case "Last Month":
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "This Year":
                from = new Date(today.getFullYear(), 0, 1);
                to = new Date(today.getFullYear(), 11, 31);
                break;
            case "Custom Range":
                return { fromDate: customFromDate, toDate: customToDate };
            default:
                return null;
        }

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            fromDate: formatDate(from),
            toDate: formatDate(to),
        };
    };

    // Filter by date range (frontend)
    const filterByDateRange = (items) => {
        const range = getDateRangeFromSelection();
        if (!range) return items;

        const startDate = new Date(range.fromDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(range.toDate);
        endDate.setHours(23, 59, 59, 999);

        return items.filter(item => {
            const registerDate = item.createdAt ? new Date(item.createdAt) : null;
            if (!registerDate) return false;
            return registerDate >= startDate && registerDate <= endDate;
        });
    };

    // Calculate Stats
    const calculateStats = (dataArray) => {
        const total = dataArray.length;
        const verified = dataArray.filter(p => p.verified === true).length;
        const pending = dataArray.filter(p => p.verified !== true).length;
        const online = dataArray.filter(p => p.online === true).length;

        // Calculate today's riders
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const todayRiders = dataArray.filter(item => {
            const registerDate = item.createdAt ? new Date(item.createdAt) : null;
            if (!registerDate) return false;
            return registerDate >= today && registerDate < tomorrow;
        }).length;

        setStats({ total, verified, pending, online, todayRiders });
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            console.error("No auth token found");
            return;
        }

        const fetchPartners = async () => {
            try {
                showLoader();
                const data = await getAllDeliveryPartners(token);
                setPartnersData(data);
                calculateStats(data);
            } catch (err) {
                console.error("Partners fetch error:", err);
            } finally {
                hideLoader();
            }
        };

        fetchPartners();
    }, [refreshKey]);

    // Combined filter with search and date
    const searchFilteredData = useMemo(() => {
        let data = partnersData;

        // Apply date filter
        data = filterByDateRange(data);

        if (vehicleFilter) {
            data = data.filter((i) =>
                i.vehicleTypes?.includes(vehicleFilter) ||
                i.vehicles?.includes(vehicleFilter)
            );
        }

        if (cityFilter) {
            data = data.filter((i) => i.city?.toLowerCase().includes(cityFilter.toLowerCase()));
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            data = data.filter(partner => {
                let fieldValue;

                if (searchType === "phoneNumber") {
                    fieldValue = partner.phoneNumber || partner.maskedPhoneNumber;
                } else if (searchType === "email") {
                    fieldValue = partner.email || partner.maskedEmail;
                } else {
                    fieldValue = partner[searchType];
                }

                if (!fieldValue) return false;

                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        const sortedData = [...data].sort((a, b) =>
            String(b.partnerId || "").localeCompare(
                String(a.partnerId || ""),
                undefined,
                { numeric: true, sensitivity: "base" }
            )
        );

        return sortedData;
    }, [partnersData, searchQuery, searchType, vehicleFilter, cityFilter, selectedDateFilter, customFromDate, customToDate]);

    // Update filtered data for stats
    useEffect(() => {
        setFilteredData(searchFilteredData);
    }, [searchFilteredData]);

    useEffect(() => {
        if (!selectedPartner) {
            setRows(getDefaultDeliveryPartnerRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            setImageLoadErrors(new Set());
            return;
        }

        const dataSource = partnerDetails || selectedPartner;

        if (dataSource.verified === true) {
            setIsApproved(true);
        }

        const imageMap = {
            "AADHAR Number": [
                dataSource.aadharCardFront,
                dataSource.aadharCardBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "PAN Number": [dataSource.panCard]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "License Number": [
                dataSource.licenseFront,
                dataSource.licenseBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Profile Picture": [dataSource.profilePicture]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "RC Number": [
                dataSource.rcBookFront,
                dataSource.rcBookBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
        };

        const newRows = [
            { key: "Full Name", value: dataSource.fullName || "N/A" },
            { key: "Phone Number", value: dataSource.phoneNumber || "N/A" },
            { key: "Email", value: dataSource.email || "N/A" },
            { key: "Profile Picture", value: "Profile Picture" },
            { key: "AADHAR Number", value: dataSource.aadharNumber || "N/A" },
            { key: "PAN Number", value: dataSource.panNumber || "N/A" },
            { key: "License Number", value: dataSource.licenseNumber || "N/A" },
            {
                key: "Vehicle Types",
                value: Array.isArray(dataSource.vehicleTypes)
                    ? dataSource.vehicleTypes
                    : (dataSource.vehicleTypes ? [dataSource.vehicleTypes] : [])
            },
            {
                key: "Vehicles",
                value: Array.isArray(dataSource.vehicles)
                    ? dataSource.vehicles
                    : (dataSource.vehicles ? [dataSource.vehicles] : [])
            },
            {
                key: "Petrolium Types",
                value: Array.isArray(dataSource.petroliumTypes)
                    ? dataSource.petroliumTypes
                    : (dataSource.petroliumTypes ? [dataSource.petroliumTypes] : [])
            },
            {
                key: "RC Number",
                value: Array.isArray(dataSource.rcNumber) && dataSource.rcNumber.length > 0
                    ? dataSource.rcNumber[0]
                    : dataSource.rcNumber || "N/A"
            },
            {
                key: "Insurance Number",
                value: Array.isArray(dataSource.insuranceNumber) && dataSource.insuranceNumber.length > 0
                    ? dataSource.insuranceNumber[0]
                    : dataSource.insuranceNumber || "N/A"
            },
            {
                key: "Bank Details",
                value: {
                    bankName: dataSource.bankName || "N/A",
                    accountNumber: dataSource.accountNumber || "N/A",
                    accountHolderName: dataSource.accountHolderName || "N/A",
                    ifscCode: dataSource.ifscCode || "N/A",
                    branchName: dataSource.branchName || "N/A",
                    upiId: dataSource.upiId || "N/A",
                },
            },
            {
                key: "Current Address",
                value: {
                    address: dataSource.address || "N/A",
                    city: dataSource.city || "N/A",
                    state: dataSource.state || "N/A",
                    pinCode: dataSource.pinCode || "N/A",
                    country: dataSource.country || "N/A",
                    houseNo: dataSource.houseNo || "N/A",
                    street: dataSource.street || "N/A",
                },
            },
            {
                key: "Permanent Address",
                value: {
                    permanentAddress: dataSource.permanentAddress || "N/A",
                    permanentCity: dataSource.permanentCity || "N/A",
                    permanentState: dataSource.permanentState || "N/A",
                    permanentPinCode: dataSource.permanentPinCode || "N/A",
                    permanentCountry: dataSource.permanentCountry || "N/A",
                    permanentHouseNo: dataSource.permanentHouseNo || "N/A",
                    permanentStreet: dataSource.permanentStreet || "N/A",
                },
            },
        ];

        const updatedRows = newRows.map((row) => ({
            ...row,
            images: imageMap[row.key] || [],
        }));

        setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
        setVerifiedRows([]);
        setRejectedRows([]);
        setImageLoadErrors(new Set());
    }, [selectedPartner, partnerDetails]);

    const handleViewClick = (partner) => {
        setSelectedPartner(partner);
        const partnerId = partner?.id || partner?.partnerId;
        fetchPartnerDetails(partnerId);
    };

    const handleVerifyy = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            console.warn("No status mapping for:", rows[i].key);
            return;
        }

        const partnerId = getCurrentPartnerId();
        if (!partnerId) return alert("Partner ID is missing");

        try {
            const updateData = { [statusField]: true };
            const formData = new FormData();
            formData.append(
                "partnerData",
                new Blob([JSON.stringify(updateData)], { type: "application/json" })
            );

            await verifyPartnerField(partnerId, formData, localStorage.getItem("authToken"));
            await fetchPartnerDetails(partnerId);
            alert("Partner field verified successfully!");
        } catch (err) {
            console.error("❌ Verify error:", err);
            alert(`Failed to verify field: ${err.message}`);
        }
    };

    const handleReject = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) return;

        const partnerId = getCurrentPartnerId();
        if (!partnerId) return alert("Partner ID is missing");

        try {
            const updateData = { [statusField]: false };
            const formData = new FormData();
            formData.append(
                "partnerData",
                new Blob([JSON.stringify(updateData)], { type: "application/json" })
            );

            await rejectPartnerField(partnerId, formData, localStorage.getItem("authToken"));
            alert("Partner field rejected successfully!");
            fetchPartnerDetails(partnerId);
        } catch (err) {
            console.error("❌ Reject error:", err);
            alert(`Failed to reject field: ${err.message}`);
        }
    };

    const handleApproveAll = async () => {
        const partnerId = getCurrentPartnerId();
        if (!partnerId) {
            alert("Partner ID is missing");
            return;
        }

        setIsApproving(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Authorization token missing");
                return;
            }

            const payload = { rejectReason: "", verified: true };
            const data = await approvePartner(partnerId, payload, token);

            if (data) {
                alert("✅ Partner approved successfully!");
                setPartnerDetails(prev => ({ ...prev, ...data, verified: true }));
                setSelectedPartner(prev => ({ ...prev, ...data, verified: true }));
                setPartnersData(prev =>
                    prev.map(partner =>
                        partner.id === partnerId || partner.partnerId === partnerId
                            ? { ...partner, ...data, verified: true }
                            : partner
                    )
                );
                setIsApproved(true);
                setTimeout(() => setRefreshKey(prev => prev + 1), 1000);
            } else {
                alert("⚠️ Approval failed. Empty response from backend.");
            }
        } catch (err) {
            console.error("❌ Approve partner error:", err);
            const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message;
            alert(`Failed to approve partner: ${errorMessage}`);
        } finally {
            setIsApproving(false);
        }
    };

    const handleRejectAll = async () => {
        if (!rejectionDescription.trim()) {
            alert("Please enter a rejection reason");
            return;
        }

        const partnerId = getCurrentPartnerId();
        if (!partnerId) return alert("Partner ID is missing");

        setIsRejecting(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) return alert("Authorization token missing");

            const requestBody = {
                verified: false,
                rejectReason: rejectionDescription.trim()
            };

            const data = await rejectPartnerApproval(partnerId, requestBody, token);

            setShowRejectDropdown(false);
            setRejectionDescription("");

            if (data) {
                alert("Partner verification rejected successfully!");
                setPartnersData(prev =>
                    prev.map(partner =>
                        partner.id === partnerId || partner.partnerId === partnerId
                            ? { ...partner, verified: false, rejectReason: rejectionDescription }
                            : partner
                    )
                );
                setPartnerDetails(prev => ({ ...prev, verified: false, rejectReason: rejectionDescription }));
                setSelectedPartner(prev => ({ ...prev, verified: false, rejectReason: rejectionDescription }));
                setIsApproved(false);
                setTimeout(() => setRefreshKey(prev => prev + 1), 1000);
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (err) {
            console.error("❌ Reject error:", err);
            const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message || "Failed to reject partner";
            alert(`Failed to reject: ${errorMessage}`);
        } finally {
            setIsRejecting(false);
        }
    };

    const handleBackClick = () => setSelectedPartner(null);

    const handleExportFiltered = () => {
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : partnersData;

        if (exportData.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = [
            "S.NO", "Partner ID", "Full Name", "Email", "Phone Number",
            "City", "Vehicle Types", "Verified Status", "Online Status"
        ];

        const csvRows = exportData.map((partner, index) => [
            index + 1,
            partner.partnerId || 'N/A',
            partner.fullName || 'N/A',
            partner.email || partner.maskedEmail || 'N/A',
            partner.phoneNumber || partner.maskedPhoneNumber || 'N/A',
            partner.city || 'N/A',
            Array.isArray(partner.vehicleTypes) ? partner.vehicleTypes.join(", ") : 'N/A',
            partner.verified ? "Verified" : "Pending",
            partner.online ? "Online" : "Offline"
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "subscribed_logistics_partners.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const getDateFilterDisplayText = () => {
        if (selectedDateFilter === "All") return "All";
        if (selectedDateFilter === "Custom Range") {
            return `${customFromDate} to ${customToDate}`;
        }
        return selectedDateFilter;
    };

    const handleDateFilterSelect = (filter) => {
        setSelectedDateFilter(filter);
        if (filter === "Custom Range") {
            setShowCustomPicker(true);
        } else {
            setShowCustomPicker(false);
            setShowDateDropdown(false);
        }
    };

    const applyCustomRange = () => {
        setShowCustomPicker(false);
        setShowDateDropdown(false);
    };

    const ImageDisplay = ({ images, fieldName }) => {
        if (!images || images.length === 0) {
            return (
                <div className="text-center">
                    <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                </div>
            );
        }

        return (
            <div className="d-flex justify-content-center gap-2 flex-wrap">
                {images.map((img, idx) => {
                    const imageUrl = typeof img === 'string' ? img : img.url;
                    const hasFailed = isImageFailed(fieldName, idx);

                    if (hasFailed || !imageUrl) {
                        return (
                            <div key={idx} className="text-center">
                                <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className="text-center position-relative">
                            <img
                                src={imageUrl}
                                alt={`${fieldName}-${idx}`}
                                style={{
                                    width: fieldName === "Profile Picture" ? "80px" : "60px",
                                    height: fieldName === "Profile Picture" ? "80px" : "60px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    border: "2px solid #e2e8f0",
                                    transition: "transform 0.2s ease"
                                }}
                                onError={() => handleImageError(imageUrl, fieldName, idx)}
                                onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div style={styles.container}>
            {!selectedPartner ? (
                <>
                  

                    {/* Dashboard Stats Cards */}
                    <div style={styles.statsGrid}>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>Total Riders</span>
                                <span style={styles.statCardValue}>{stats.total}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#eef2ff' }}>
                                <Icons.Users />
                            </div>
                        </div>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>Verified</span>
                                <span style={{ ...styles.statCardValue, color: '#16a34a' }}>{stats.verified}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#dcfce7' }}>
                                <Icons.CheckCircle />
                            </div>
                        </div>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>Pending</span>
                                <span style={{ ...styles.statCardValue, color: '#f59e0b' }}>{stats.pending}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#fef3c7' }}>
                                <Icons.Clock />
                            </div>
                        </div>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>Online</span>
                                <span style={{ ...styles.statCardValue, color: '#2563eb' }}>{stats.online}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#dbeafe' }}>
                                <Icons.Online />
                            </div>
                        </div>
                        <div style={styles.statCard}>
                            <div style={styles.statCardLeft}>
                                <span style={styles.statCardLabel}>
                                    {selectedDateFilter === "Today" ? "Today's Riders" : 
                                     selectedDateFilter === "All" ? "All Riders" : 
                                     `${selectedDateFilter} Riders`}
                                </span>
                                <span style={{ ...styles.statCardValue, color: '#e66d33' }}>{filteredData.length}</span>
                            </div>
                            <div style={{ ...styles.statCardIcon, background: '#fef3e8' }}>
                                <Icons.Today />
                            </div>
                        </div>
                    </div>

                    {/* Filters */}
                    <div style={styles.filtersContainer}>
                        <div style={styles.searchGroup}>
                            <select
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                                style={styles.select}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                            <input
                                type="text"
                                placeholder={getPlaceholderText()}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    ...styles.input,
                                    borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                                }}
                            />
                        </div>

                        {/* Date Filter */}
                        <div ref={dateDropdownRef} style={{ position: "relative" }}>
                            <button
                                onClick={() => setShowDateDropdown(!showDateDropdown)}
                                style={{
                                    ...styles.dateFilterBtn,
                                    ...(showDateDropdown ? styles.dateFilterBtnActive : {})
                                }}
                            >
                                <Calendar size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                                <span>{getDateFilterDisplayText()}</span>
                                <ChevronDown size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                            </button>

                            {showDateDropdown && !showCustomPicker && (
                                <div style={{
                                    position: "absolute",
                                    top: "45px",
                                    left: 0,
                                    background: "white",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "12px",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                    minWidth: "180px",
                                    overflow: "hidden"
                                }}>
                                    {dateFilterOptions.map(option => (
                                        <div
                                            key={option}
                                            onClick={() => handleDateFilterSelect(option)}
                                            style={{
                                                padding: "10px 16px",
                                                fontSize: "13px",
                                                cursor: "pointer",
                                                background: selectedDateFilter === option ? "#fef3e8" : "white",
                                                color: selectedDateFilter === option ? "#e66d33" : "#334155",
                                                borderBottom: "1px solid #f0f0f0"
                                            }}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {showCustomPicker && (
                                <div style={{
                                    position: "absolute",
                                    top: "45px",
                                    left: 0,
                                    background: "white",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "12px",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                    width: "280px",
                                    padding: "16px"
                                }}>
                                    <div style={{ marginBottom: "12px" }}>
                                        <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>From Date</label>
                                        <input
                                            type="date"
                                            value={customFromDate}
                                            onChange={(e) => setCustomFromDate(e.target.value)}
                                            style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                            max={customToDate}
                                        />
                                    </div>
                                    <div style={{ marginBottom: "16px" }}>
                                        <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>To Date</label>
                                        <input
                                            type="date"
                                            value={customToDate}
                                            onChange={(e) => setCustomToDate(e.target.value)}
                                            style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                            min={customFromDate}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                    <button
                                        onClick={applyCustomRange}
                                        style={{ width: "100%", padding: "10px", background: "#e66d33", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}
                                    >
                                        Apply Range
                                    </button>
                                </div>
                            )}
                        </div>

                        <select
                            value={vehicleFilter}
                            onChange={(e) => setVehicleFilter(e.target.value)}
                            style={{ ...styles.select, minWidth: '110px' }}
                        >
                            <option value="">All Vehicles</option>
                            {vehicleTypeOptions.map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </select>

                        <button
                            onClick={clearAllFilters}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            <Icons.Clear /> Clear
                        </button>

                        <button
                            onClick={handleExportFiltered}
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                        >
                            <Icons.Export /> Export
                        </button>

                        {(searchQuery || vehicleFilter || cityFilter || selectedDateFilter !== "Today") && (
                            <span style={{ fontSize: '12px', color: '#718096' }}>
                                <strong>{filteredData.length}</strong> result{filteredData.length !== 1 && 's'}
                            </span>
                        )}
                    </div>

                    {/* Table */}
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.thead}>
                                <tr>
                                    <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
                                    <th style={styles.th}>Partner ID</th>
                                    <th style={styles.th}>Full Name</th>
                                    <th style={styles.th}>Email</th>
                                    <th style={styles.th}>Mobile</th>
                                    <th style={styles.th}>City</th>
                                </tr>
                            </thead>
                            <tbody>
                                {searchFilteredData.length ? (
                                    searchFilteredData.map((partner, idx) => (
                                        <tr
                                            key={partner.id || idx}
                                            style={{
                                                backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                transition: 'background 0.15s ease'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                        >
                                            <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>{idx + 1}</td>
                                            <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                                {partner?.partnerId || "—"}
                                            </td>
                                            <td style={{ ...styles.td, fontWeight: '500' }}>
                                                {partner?.fullName || "—"}
                                            </td>
                                            <td style={{ ...styles.td, color: '#4a5568' }}>
                                                {partner?.maskedEmail || partner?.email || "—"}
                                            </td>
                                            <td style={styles.td}>
                                                {partner?.maskedPhoneNumber || partner?.phoneNumber || "—"}
                                            </td>
                                            <td style={styles.td}>
                                                {partner?.city || "—"}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ padding: 0 }}>
                                            <div style={styles.emptyState}>
                                                <Icons.NoData />
                                                <div style={styles.emptyStateText}>
                                                    {partnersData.length === 0 ? 'Loading partners...' : 'No partners found'}
                                                </div>
                                                <div style={styles.emptyStateSubtext}>
                                                    {partnersData.length === 0
                                                        ? 'Please wait while we fetch the data'
                                                        : (searchQuery.trim() || vehicleFilter || cityFilter || selectedDateFilter !== "Today")
                                                            ? 'Try adjusting your filters to see more results'
                                                            : 'No subscribed logistics partners are available'}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                /* ============ DETAIL VIEW ============ */
                <div>
                    {/* Detail Header */}
                    <div style={styles.detailHeader}>
                        <button
                            onClick={handleBackClick}
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                        >
                            <Icons.Back /> Back
                        </button>
                        <div style={styles.detailTitle}>
                            Partner Details — <span style={{ color: 'rgb(230 109 51)' }}>
                                {selectedPartner?.fullName || 'N/A'}
                            </span>
                        </div>
                        {partnerDetails?.verified === true || isApproved ? (
                            <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
                                <Icons.Approved /> Approved
                            </span>
                        ) : (
                            <span style={{ ...styles.statusBadge, ...styles.statusPending }}>
                                <Icons.Offline /> Pending
                            </span>
                        )}
                        <button
                            onClick={refreshAllData}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            <Icons.Refresh /> Refresh
                        </button>
                    </div>

                    {loading && (
                        <div className="text-center my-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {!loading && (
                        <>
                            <div style={styles.detailTableWrapper}>
                                <table style={styles.detailTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.detailTh}>Field</th>
                                            <th style={styles.detailTh}>Value</th>
                                            <th style={styles.detailTh}>Image</th>
                                            <th style={styles.detailTh}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((r, i) => {
                                            const isEditing = r.isEditing || false;

                                            const handleInputChange = (field, value) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) =>
                                                        idx === i
                                                            ? {
                                                                ...row,
                                                                value:
                                                                    typeof row.value === "object"
                                                                        ? { ...row.value, [field]: value }
                                                                        : value,
                                                            }
                                                            : row
                                                    )
                                                );
                                            };

                                            const handleArraySelection = (selectedValue) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) => {
                                                        if (idx === i) {
                                                            const currentValues = Array.isArray(row.value) ? row.value : [];
                                                            const isSelected = currentValues.includes(selectedValue);

                                                            if (isSelected) {
                                                                return {
                                                                    ...row,
                                                                    value: currentValues.filter(v => v !== selectedValue)
                                                                };
                                                            } else {
                                                                return {
                                                                    ...row,
                                                                    value: [...currentValues, selectedValue]
                                                                };
                                                            }
                                                        }
                                                        return row;
                                                    })
                                                );
                                            };

                                            const handleImageChange = (e) => {
                                                const files = Array.from(e.target.files);
                                                const newImages = files.map((file) => ({
                                                    url: URL.createObjectURL(file),
                                                    file
                                                }));

                                                setRows(prev =>
                                                    prev.map((row, idx) =>
                                                        idx === i
                                                            ? {
                                                                ...row,
                                                                images: [...(row.images || []), ...newImages]
                                                            }
                                                            : row
                                                    )
                                                );
                                            };

                                            const getOptions = () => {
                                                switch (r.key) {
                                                    case "Vehicle Types": return vehicleTypeOptions;
                                                    case "Vehicles": return vehiclesOptions;
                                                    case "Petrolium Types": return petroliumTypeOptions;
                                                    default: return [];
                                                }
                                            };

                                            return (
                                                <tr key={r.key || i}>
                                                    <td style={{ ...styles.detailTd, fontWeight: '600' }}>{r.key}</td>

                                                    <td style={styles.detailTd}>
                                                        {r.key === "Vehicle Types" || r.key === "Vehicles" || r.key === "Petrolium Types" ? (
                                                            isEditing ? (
                                                                <div className="d-flex flex-column gap-1">
                                                                    {getOptions().map((option) => {
                                                                        const currentValues = Array.isArray(r.value) ? r.value : [];
                                                                        const isSelected = currentValues.includes(option);

                                                                        return (
                                                                            <div key={option} className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    id={`${r.key}-${option}-${i}`}
                                                                                    checked={isSelected}
                                                                                    onChange={() => handleArraySelection(option)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`${r.key}-${option}-${i}`}
                                                                                >
                                                                                    {option}
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            ) : (
                                                                Array.isArray(r.value) && r.value.length > 0
                                                                    ? r.value.join(", ")
                                                                    : "N/A"
                                                            )
                                                        ) : r.key === "Bank Details" ? (
                                                            Object.entries(r.value || {}).map(([field, value]) => (
                                                                <div key={field} className="mb-1">
                                                                    <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
                                                                    {isEditing ? (
                                                                        <input
                                                                            type="text"
                                                                            value={value || ""}
                                                                            onChange={(e) => handleInputChange(field, e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        safeDisplay(value)
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : r.key === "Current Address" || r.key === "Permanent Address" ? (
                                                            Object.entries(r.value || {}).map(([field, value]) => (
                                                                <div key={field} className="mb-1">
                                                                    <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
                                                                    {isEditing ? (
                                                                        <input
                                                                            type="text"
                                                                            value={value || ""}
                                                                            onChange={(e) => handleInputChange(field, e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        safeDisplay(value)
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : r.key === "Profile Picture" ? (
                                                            "Profile Picture"
                                                        ) : r.key === "RC Number" || r.key === "Insurance Number" ? (
                                                            isEditing ? (
                                                                <input
                                                                    type="text"
                                                                    value={r.value || ""}
                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            ) : (
                                                                safeDisplay(r.value)
                                                            )
                                                        ) : (
                                                            isEditing ? (
                                                                <input
                                                                    type="text"
                                                                    value={r.value || ""}
                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            ) : (
                                                                safeDisplay(r.value)
                                                            )
                                                        )}
                                                    </td>

                                                    <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                        {isEditing ? (
                                                            <>
                                                                <input
                                                                    type="file"
                                                                    multiple={r.key === "AADHAR Number" || r.key === "License Number" || r.key === "RC Number"}
                                                                    accept="image/*"
                                                                    onChange={handleImageChange}
                                                                    className="form-control mb-2"
                                                                />
                                                                <ImageDisplay images={r.images} fieldName={r.key} />
                                                            </>
                                                        ) : (
                                                            <ImageDisplay images={r.images} fieldName={r.key} />
                                                        )}
                                                    </td>

                                                    <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                        {isEditing ? (
                                                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                                <button
                                                                    className="btn btn-sm btn-success"
                                                                    onClick={() => handleSaveRow(i)}
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    <Icons.Save /> Save
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={() =>
                                                                        setRows((prev) =>
                                                                            prev.map((row, idx) =>
                                                                                idx === i ? { ...row, isEditing: false } : row
                                                                            )
                                                                        )
                                                                    }
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                                {isFieldVerified(r.key, r.value, partnerDetails) ? (
                                                                    <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
                                                                        <Icons.Check /> Verified
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-sm btn-warning"
                                                                        onClick={() => handleVerifyy(i)}
                                                                        disabled={
                                                                            isFieldVerified(r.key, r.value, partnerDetails) ||
                                                                            isFieldRejected(r.key, partnerDetails)
                                                                        }
                                                                        style={{ minWidth: 70 }}
                                                                    >
                                                                        Verify
                                                                    </button>
                                                                )}

                                                                {isFieldRejected(r.key, partnerDetails) ? (
                                                                    <span style={{ ...styles.statusBadge, ...styles.statusOffline }}>
                                                                        <Icons.X /> Rejected
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-sm btn-secondary"
                                                                        onClick={() => handleReject(i)}
                                                                        disabled={
                                                                            isFieldRejected(r.key, partnerDetails) ||
                                                                            isFieldVerified(r.key, r.value, partnerDetails)
                                                                        }
                                                                        style={{ minWidth: 70 }}
                                                                    >
                                                                        Reject
                                                                    </button>
                                                                )}

                                                                <button
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() =>
                                                                        setRows((prev) =>
                                                                            prev.map((row, idx) =>
                                                                                idx === i ? { ...row, isEditing: true } : row
                                                                            )
                                                                        )
                                                                    }
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    <Icons.Edit /> Edit
                                                                </button>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Approval Section */}
                            <div style={styles.approvalContainer}>
                                {partnerDetails?.verified === true || isApproved ? (
                                    <span style={{ ...styles.statusBadge, ...styles.statusVerified, fontSize: '14px', padding: '6px 20px' }}>
                                        <Icons.Approved /> Approved ✓
                                    </span>
                                ) : (
                                    <>
                                        <button
                                            className="btn btn-success px-4 py-2 fw-bold"
                                            style={{ minWidth: "120px" }}
                                            onClick={handleApproveAll}
                                            disabled={isApproving || isRejecting}
                                        >
                                            {isApproving ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Approving...
                                                </>
                                            ) : (
                                                "Approve"
                                            )}
                                        </button>

                                        <div className="position-relative">
                                            {showRejectDropdown ? (
                                                <div style={styles.rejectCard}>
                                                    <div className="mb-3">
                                                        <label className="form-label fw-bold">Rejection Reason</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows="3"
                                                            placeholder="Enter rejection reason..."
                                                            value={rejectionDescription}
                                                            onChange={(e) => setRejectionDescription(e.target.value)}
                                                            disabled={isApproving || isRejecting}
                                                        />
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            className="btn btn-danger flex-grow-1"
                                                            onClick={handleRejectAll}
                                                            disabled={!rejectionDescription.trim() || isApproving || isRejecting}
                                                        >
                                                            {isRejecting ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                                    Rejecting...
                                                                </>
                                                            ) : (
                                                                "Confirm Reject"
                                                            )}
                                                        </button>
                                                        <button
                                                            className="btn btn-secondary"
                                                            onClick={() => {
                                                                setShowRejectDropdown(false);
                                                                setRejectionDescription("");
                                                            }}
                                                            disabled={isApproving || isRejecting}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <button
                                                    className="btn btn-danger px-4 py-2 fw-bold"
                                                    style={{ minWidth: "120px" }}
                                                    onClick={() => setShowRejectDropdown(true)}
                                                    disabled={isApproving || isRejecting}
                                                >
                                                    {isRejecting ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                            Rejecting...
                                                        </>
                                                    ) : (
                                                        "Reject"
                                                    )}
                                                </button>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default Logisticssubscribedclients;